/* eslint camelcase: "off" */
/**
 * @implements {GMMLoader}
 * @memberof module:GTMLoader
 */
class GTMLoader {
  constructor({ config }) {
    this.account = config.GTM_ACCOUNT;
  }

  loadScript() {
    if (!this.account) {
      return;
    }

    global.google_tag_manager = global.google_tag_manager || [];
    const { google_tag_manager } = global;

    // If the snippet was invoked do nothing.
    if (google_tag_manager.invoked) {
      return;
    }

    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    google_tag_manager.invoked = true;

    google_tag_manager.load = (gtm_acct) => {
      const gtmScript = document.createElement('script');
      gtmScript.type = 'text/javascript';
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${gtm_acct}');
      `;

      // Insert our scripts next to the first script element.
      const first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(gtmScript, first);
    };

    // Load gtmAnalytics.
    google_tag_manager.load(this.account);
  }
}

export default GTMLoader;
